module.exports = __webpack_public_path__ + "static/media/pic15-min.907fe3b5.jpg";